var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-brake",attrs:{"id":"print-base-wraper"}},[_vm._t("cover"),_c('base-section'),_c('base-detail-section'),_c('PageButtomText',{staticClass:"page-splite-flag",attrs:{"text-obj":_vm.familyBaseText}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }